import EditSystemLights from './containers/EditSystemLightsContainer'

export default EditSystemLights
